import { Navigate } from "react-router";
import { useGetForestOwnerQuery } from "../../../apis/ForestOwner.api";
import { PrimaryForestOwner, ForestOwner } from "../../../types/models/ForestOwner";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const ForestOwnerScoped = () => {
    const {
        data,
    } = useGetForestOwnerQuery(PrimaryForestOwner.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/forest-owners/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default ForestOwnerScoped;
